import { IconName } from '@infotech-soe/erp-ui-kit';
import { THotKey } from '@infotech-soe/metaschema';

import { TActionArgsValues } from '../../../infrastructure/providers/abstract/IApiProvider';
import { Caption, CaptionType } from '../../../models/caption/Caption';
import { DEFAULT_ACTION_ICON } from '../../../ui/components/menu/constants';
import CategoryCommandImpl from '../impl/CategoryCommandImpl';

import CategoryCommand from './CategoryCommand';

class RunActionCommand extends CategoryCommand<TActionArgsValues> {
  constructor(
    private caption: string,
    commandImpl: CategoryCommandImpl<TActionArgsValues>,
    private icon?: IconName,
    private menuLabel?: string,
    private hotKey?: THotKey
  ) {
    super(commandImpl);
  }

  public async getCaption(): Promise<Caption> {
    return {
      type: CaptionType.EXTERNAL,
      caption: this.caption,
    };
  }

  public getIcon(): IconName {
    return this.icon ?? DEFAULT_ACTION_ICON;
  }

  public getMenuLabel(): string | undefined {
    return this.menuLabel;
  }

  public getHotKey(): THotKey | undefined {
    return this.hotKey;
  }
}

export default RunActionCommand;
